<template>
  <!-- 新建工单-工单头部部分 -->
  <div>
    <el-form
      :model="workOrderHeader"
      :rules="workOrderHeaderRelues"
      ref="workOrderHeaderFormRef"
      inline
      size="mini"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="设备类型" prop="deviceKind">
            <!-- 部门 -->
            <el-select
              v-model="workOrderHeader.deviceKind"
              placeholder="请选择设备类型"
              clearable
              filterable
              @blur="selectBlur"
              @clear="selectClear"
              @change="selectChange"
            >
              <el-option
                v-for="(item, index) in deviceKind"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备编号" prop="deviceNo">
            <el-input
              v-model="workOrderHeader.deviceNo"
              disabled="isDisabled"
              placeholder="自动生成"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="部门" prop="depart">
            <!-- 部门 -->
            <el-select
              v-model="workOrderHeader.depart"
              placeholder="请选择部门"
              clearable
              filterable
              @blur="selectBlur1"
              @clear="selectClear1"
              @change="selectChange1"
            >
              <el-option
                v-for="(item, index) in departmentList"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="设备名称" prop="deviceName">
            <el-input
              v-model="workOrderHeader.deviceName"
              placeholder="请输入设备名称"
              clearable
            >
            </el-input>
          </el-form-item>

          <el-form-item label="采购日期" prop="purchaseDate">
            <el-date-picker
              v-model="workOrderHeader.purchaseDate"
              align="right"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions"
              format="yyyy-MM-dd"
              value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="供应商" prop="provider">
            <el-input
              v-model="workOrderHeader.provider"
              placeholder="请输入供应商"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="单位" prop="unit">
            <el-select
              v-model="workOrderHeader.unit"
              placeholder="请选择单位"
              clearable
            >
              <el-option
                v-for="(item, index) in unit"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="数量" prop="deviceCount">
            <el-input
              v-model="workOrderHeader.deviceCount"
              placeholder="请输入数量"
              clearable
            >
            </el-input>
          </el-form-item>

          <el-form-item label="登记员" prop="creator">
            <el-input
              v-model="workOrderHeader.creator"
              placeholder="请输入登记员"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="备注" prop="XXXXXXXX">
            <el-input
              v-model="workOrderHeader.remark"
              placeholder="请输入内容"
              style="width: 970px;height: 160px;"
              type="textarea"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    machineList: {
      type: Array,
      default() {
        return [
          {
            id: "1",
            number: "001",
          },
        ];
      },
    },
  },
  data() {
    return {
      workOrderHeader: {
        createTime: new Date().getTime(),
        creator: "",
        creatorId: 0,
        depart: "",
        deviceCount: 1,
        deviceKind: "",
        deviceName: "",
        deviceNo: "",
        deviceState: 0,
        factoryId: 0,
        id: 0,
        provider: "",
        purchaseDate: "",
        remark: "",
        unit: "台",
        updateTime: 0,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      // 部门下拉选择框--sta
      deviceKind: [
        {
          label: "空调内机",
          value: "0",
        },
        {
          label: "空调外机",
          value: "1",
        },
        {
          label: "电脑主机",
          value: "2",
        },
        {
          label: "电脑显示器",
          value: "3",
        },
        {
          label: "打印机",
          value: "4",
        },
      ],
      unit: [
        {
          label: "台",
          value: "0",
        },
        {
          label: "个",
          value: "1",
        },
      ],
      departmentList: [
        {
          label: "生产部",
          value: "0",
        },
        {
          label: "仓库",
          value: "1",
        },
        {
          label: "管理部",
          value: "2",
        },
      ],
      // 部门下拉选择框--end
      workOrderHeaderRelues: {
        deviceKind: [
          {
            required: true,
            message: "请输入设备类型",
            trigger: "blur",
          },
        ],
        depart: [
          {
            required: true,
            message: "请输入部门",
            trigger: "blur",
          },
        ],
        deviceName: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: "blur",
          },
        ],
        purchaseDate: [
          {
            required: true,
            message: "请输入采购时间",
            trigger: "blur",
          },
        ],
        // provider: [
        //   {
        //     required: true,
        //     message: "请输入供应商",
        //     trigger: "blur",
        //   },
        // ],
        unit: [
          {
            required: true,
            message: "请输入单位",
            trigger: "blur",
          },
        ],
        deviceCount: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    selectBlur(e) {
      // 意见类型
      if (e.target.value !== "") {
        this.workOrderHeader.deviceKind = e.target.value;
        this.$forceUpdate(); // 强制更新
      }
    },
    selectClear() {
      this.workOrderHeader.deviceKind = "";
      this.$forceUpdate();
    },
    selectChange(val) {
      this.workOrderHeader.deviceKind = val;
      this.$forceUpdate();
    },
    selectBlur1(e) {
      // 意见类型
      if (e.target.value !== "") {
        this.workOrderHeader.depart = e.target.value;
        this.$forceUpdate(); // 强制更新
      }
    },
    selectClear1() {
      this.workOrderHeader.depart = "";
      this.$forceUpdate();
    },
    selectChange1(val) {
      this.workOrderHeader.depart = val;
      this.$forceUpdate();
    },

    // 外部调用，获取生产单头部
    getWorkOrderHeader() {
      const cloneHeader = this._.cloneDeep(this.workOrderHeader);
      return cloneHeader;
    },
    // 外部调用，验证必填的输入框是否都有填写
    getValid() {
      this.$refs.workOrderHeaderFormRef.validate((valid) => {
        this.valid = valid;
      });
      return this.valid;
    },

    // 设置表头信息
    setworkOrderHeader(response, type) {
      this.workOrderHeader = this.formatworkOrderHeader(response, type);
      console.log(this.workOrderHeader);

      //解决bug: "选择胚布"按钮 只能首次生效，第2次之后点击，editbox数据无法刷新。
      // this.$set(this.workOrderHeader, "name_change", response.craftsheet.name); //物料名称
      // this.$set(
      //   this.workOrderHeader,
      //   "number_change",
      //   response.craftsheet.number
      // ); //物料编号
    },
    // 格式化表单信息
    formatworkOrderHeader(res, type) {
      switch (type) {
        case 1: // 编辑
          // 因为 必填项 不能跨对象，所以要把 '胚布编号' 和 '胚布名称' 抢救回来。-注意要用上面的set
          //res.number_change = res.craftsheet.number // 胚布编号
          //res.name_change = res.craftsheet.name // 胚布名称
          break;

        case 0: // 新建
        default:
          break;
      }
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 50px;
  padding: 0 12px 0 0;
  width: 80px !important;
  box-sizing: border-box;
}

.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
  height: 40px;
}
</style>
